<template>
  <div class="right-column">
    <!-- {{ user }} -->
    <form @submit.prevent>
      <p class="header">Notifications</p>
      <p class="description">
        Manage email notifications
      </p>

      <!-- order confirmation setting here -->
      <div class="notification-option">
        <label class="checkbox-container">
          <p>Order confirmations</p>
          <input
            type="checkbox"
            v-model="
              user.emailNotificationPreferences.sendOrderConfirmationEmail
            "
            @change="handleEmailUpdate"
          />
          <span class="checkmark "></span>

          <!-- Tooltip Here -->
          <div class="tool-tip">
            <Tooltip
              :popOverContent="content.order"
              :popOverPosition="tooltipPosition"
              icon="i"
            />
          </div>
        </label>
      </div>

      <!-- shipping confirmation setting here -->
      <div class="notification-option">
        <label class="checkbox-container">
          <p>Shipping confirmations</p>
          <input
            type="checkbox"
            v-model="
              user.emailNotificationPreferences.sendShippingConfirmationEmail
            "
            @change="handleEmailUpdate"
          />
          <span class="checkmark "></span>

          <!-- Tooltip Here -->
          <div class="tool-tip">
            <Tooltip
              :popOverContent="content.shipping"
              :popOverPosition="tooltipPosition"
              icon="i"
            />
          </div>
        </label>
      </div>

      <!-- Redemption Order setting here -->
      <div class="notification-option">
        <label class="checkbox-container">
          <p>Redemption order summaries</p>
          <input
            type="checkbox"
            v-model="
              user.emailNotificationPreferences.sendGroupOrderSummaryEmail
            "
            @change="handleEmailUpdate"
          />
          <span class="checkmark "></span>

          <!-- Tooltip Here -->
          <div class="tool-tip">
            <Tooltip
              :popOverContent="content.redemption"
              :popOverPosition="tooltipPosition"
              icon="i"
            />
          </div>
        </label>
      </div>
      <!-- ecommerve Order setting here -->
      <div class="notification-option">
        <label class="checkbox-container">
          <p>E-commerce orders</p>
          <input
            type="checkbox"
            v-model="
              user.emailNotificationPreferences
                .sendECommerceOrderConfirmationEmail
            "
            @change="handleEmailUpdate"
          />
          <span class="checkmark "></span>
        </label>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import Tooltip from '../../components/Universal/ToolTipInfo.vue'

export default {
  name: 'EmailNotifications',

  components: { Tooltip },

  data() {
    return {
      orderConfirmation: false,
      content: {
        order: 'Receive an email every time an order has been confirmed.',
        shipping: 'Receive an email whenever an order has been shipped.',
        redemption:
          'Receive email with summary when all gift orders have been redeemed and finalised.'
      }
    }
  },
  methods: {
    updateUserProfile(value) {
      this.$store.dispatch('profile/updateUserProfile', {
        hideNotification: value.value ? value.value : false
      })
    },
    handleEmailUpdate: debounce(function() {
      this.updateUserProfile({ value: true })
    }, 1500)
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    tooltipPosition() {
      if (this.innerWidth < 1000) {
        return 'bottom-start'
      }
      return 'right'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.right-column {
  padding: 2.5rem 3.5rem;
  background: inherit;
  border: 1px solid $onyx;
  border-radius: 29px;
  margin-bottom: 2rem;

  p.header {
    text-align: left;
    padding-bottom: 0.5rem;
    font-size: 1.1rem;
    font-weight: normal;
    font-family: $editorial;
  }

  .description {
    font-family: $inter;
    font-weight: bold;
    text-align: left;
    margin-bottom: 2.5rem;
    font-size: 0.813rem;
  }

  .notification-option {
    margin: 2rem 0rem;
  }
}

.checkbox-container {
  p {
    text-align: left;
    margin-left: 30px;
    font-size: 0.813rem;
    align-items: center;
  }

  .tool-tip {
    margin: -3px 0px 0px 8px;
    position: relative;
    top: -2px;
  }
}

@media (max-width: 575.98px) {
  .right-column {
    padding: 2rem;
  }
}
</style>
